export const useInternetExplorer = () => {
    return !!window.MSInputMethodContext && !!document.documentMode;
};
